import { createSlice } from '@reduxjs/toolkit';
import {
  _setBookedSessionPagination,
  _setBookedSessionPaginationPreviousKey,
} from './bookedSessionPaginationAction';

const initialState = {
  bookedSessionPagination: [],
  bookedSessionPaginationPreviousKey: '',
};

export const bookedSessionPaginationSlice = createSlice({
  name: 'delta/bookedSessionPagination',
  initialState,
  reducers: {
    setBookedSessionPagination: _setBookedSessionPagination,
    setBookedSessionPaginationPreviousKey:
      _setBookedSessionPaginationPreviousKey,
    resetBookedSessionPagination: () => initialState,
  },
});

export const {
  setBookedSessionPagination,
  setBookedSessionPaginationPreviousKey,
  resetBookedSessionPagination,
} = bookedSessionPaginationSlice.actions;

export default bookedSessionPaginationSlice.reducer;
